import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import api, { extrairMensagemErro } from '../services/api';
import { PerfilRapido } from '../types/perfil';
import PerfilRapidoCard from './PerfilRapidoCard';

type Props = {
  tipo: 'tenant' | 'fornecedor';
  id: string | null;
  aberto: boolean;
  onClose: () => void;
};

const endpoint = (tipo: 'tenant' | 'fornecedor', id: string) =>
  tipo === 'tenant' ? `/tenants/${id}/perfil-rapido` : `/fornecedores/${id}/perfil-rapido`;

const PerfilRapidoModal: React.FC<Props> = ({ tipo, id, aberto, onClose }) => {
  const [perfil, setPerfil] = useState<PerfilRapido | null>(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    if (!aberto || !id) return;

    let ativo = true;
    setCarregando(true);
    setErro(null);
    setPerfil(null);

    api.get(endpoint(tipo, id))
      .then((resposta) => {
        if (!resposta.data?.dados) {
          throw new Error('PERFIL_RAPIDO_VAZIO');
        }
        if (ativo) setPerfil(resposta.data.dados as PerfilRapido);
      })
      .catch((falha) => {
        if (ativo) setErro(extrairMensagemErro(falha, 'Não foi possível carregar o perfil rápido.'));
      })
      .finally(() => {
        if (ativo) setCarregando(false);
      });

    return () => {
      ativo = false;
    };
  }, [aberto, id, tipo]);

  if (!aberto || !id) return null;

  return (
    <div className="modal-backdrop requisition-modal-overlay" onClick={onClose}>
      <div className="panel perfil-rapido-modal" onClick={(evento) => evento.stopPropagation()}>
        <div className="panel-heading">
          <h2>Ver perfil</h2>
          <button className="botao" type="button" onClick={onClose} aria-label="Fechar perfil">
            <X size={16} aria-hidden="true" />
            Fechar
          </button>
        </div>

        {carregando && <div className="inline-loading">A carregar perfil...</div>}
        {erro && <div className="alerta alerta-erro">{erro}</div>}
        {!carregando && !erro && perfil && <PerfilRapidoCard key={`${perfil.tipo}:${perfil.id}:${perfil.foto_url ?? perfil.imagem_url ?? ''}`} perfil={perfil} />}
        {!carregando && !erro && !perfil && <div className="empty-state">Sem dados de perfil para mostrar.</div>}
      </div>
    </div>
  );
};

export default PerfilRapidoModal;
